import defaultConfig from './default'
import {query} from 'qs'
import cookie from 'cookie'
import _ from "lodash";
import TpUnionLogin from '../service/tpUnionLogin'

const TPChannelType = 13
module.exports = _.merge({}, defaultConfig, {
	name: '小黑鱼',
	loginExtraHintText: '首次查询订单需要手机号验证',
	hideReview: true,
	match() {
		let userAgent = navigator.userAgent
		return userAgent.match(`BlackFish`)
	},
	login() {
		if (query.token) {
			return TpUnionLogin.getTpUserViewByPhoneToken(TPChannelType, query.token)
		} else {
			if (cookie.get('tper')) {
				return Promise.resolve()
			} else {
				return Promise.reject()
			}

		}

	},
	init() {
		this.login().catch(() => {
		})
	}
})



// WEBPACK FOOTER //
// ./src/mods/channels/blackfish.js